<template>
  <div class="footer-container">
    <div class="footer-copyright">
      <div class="footer-cols-links all-right-mobile mb-0">
        © 2025 Comligo. All rights reserved.
      </div>
      <div class="m-auto footer-cols-links-row">
        <div class="row">
          <div
            class="footer-cols-links col-lg-6 col-12 mb-0"
            @click="$router.push('/privacy-policy')"
          >
            Policies
          </div>
          <div
            class="footer-cols-links col-lg-6 col-12 mb-0"
            @click="setDialog(true)"
          >
            Cookies Consent Manager
          </div>
        </div>
      </div>
      <div class="footer-icons-group">
        <div class="footer-icons-button">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/Facebook1.png?alt=media&token=6fd2577b-ea81-4609-a01f-5c2859cec84f"
            alt="facebook-logo"
            class="footer-icons-img"
            @click="openLink('https://www.facebook.com/ComligoSpanish')"
          />
        </div>
        <div class="footer-icons-button">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/Linkedin1.png?alt=media&token=d76a56c3-a4b6-48ed-84e6-cc26a5b69aab"
            alt="linkedIn-logo"
            class="footer-icons-img"
            @click="
              openLink(
                'https://www.linkedin.com/company/learnspanishonlinecomligo'
              )
            "
          />
        </div>
        <div class="footer-icons-button">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/YT.png?alt=media&token=31642580-5f1b-4c3c-a95c-f832898e5754"
            alt="youtube-logo"
            class="footer-icons-img"
            @click="openLink('https://www.youtube.com/@Comligo')"
          />
        </div>
        <div class="footer-icons-button">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/insta.png?alt=media&token=b6ee9467-5a51-4b51-acc1-69ab061397f9"
            alt="instagram-logo"
            class="footer-icons-img"
            @click="openLink('https://www.instagram.com/comligospanish/')"
          />
        </div>
      </div>
      <div class="footer-copyright-mobile">
        © 2025 Comligo. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "FooterComponent",
  methods: {
    ...mapMutations(["setConsent", "setDialog"]),
    openLink(link) {
      window.open(`${link}`, "_blank").focus();
    },
  },
  data() {
    return {
      footer: [
        {
          title: "Courses",
          link: "/spanish-courses-overview",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
        {
          title: "Individuals",
          link: "/for-individuals",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
        {
          title: "Organizations",
          items: [
            {
              title: "For K-12 education",
              link: "/k-12-schools",
            },
            {
              title: "For IB schools",
              link: "/ib-schools",
            },
            {
              title: "For higher education",
              link: "/higher-education",
            },
            {
              title: "For private sector",
              link: "/private-sector",
            },
            {
              title: "For public sector and non-profits",
              link: "/private-sector",
            },
          ],
          link: "",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
        {
          title: "Pricing",
          link: "/spanish-course-pricing",
          icon: "mdi mdi-chevron-left",
          active: false,
        },
      ],
    };
  },
};
</script>

<style></style>
